/**
 * High level router.
 */
import React, {FC, Suspense, lazy} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage, useAuth} from '../modules/auth'
import {AutoLogin} from '../modules/auth/components/AutoLogin'
import {App} from '../App'
import {DEFAULT_AUTHENTICATED_ROUTE} from './constants'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env
const AbilityCandidatePage = lazy(() => import('../pages/ability/AbilityCandidatePage'))

const AppRoutes: FC = () => {
  const {currentUser} = useAuth()

  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          <Route path='auth/*' element={<AuthPage />} />
          <Route path='auth/autologin/:token' element={<AutoLogin />} />
          <Route
            path='ability'
            element={
              <Suspense fallback={null}>
                <AbilityCandidatePage />
              </Suspense>
            }
          />

          {currentUser ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to={DEFAULT_AUTHENTICATED_ROUTE} />} />
            </>
          ) : (
            <>
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
